import * as React from 'react';
import { Row, Col, Button } from 'reactstrap';

export interface IAlertButtonsProps {
  disabled: boolean;
  isEdit: boolean;
  clearData: () => void
}

export default class AlertButtons extends React.Component<IAlertButtonsProps> {
  public onClearData = (event) => {
    event.preventDefault();
    this.props.clearData()
  }

  public render() {
    const { disabled, isEdit } = this.props;
    return (
      <Row>
        <Col md={12}>
          <div>
            <Button type="submit" id="submitBTN" disabled={disabled} className="btn btn-outline btn-green-fill float-right">
              {isEdit ? "Update" : "Submit"}
            </Button>
            {
              !disabled && !isEdit &&
              <Button id={"clearBTN"} onClick={this.onClearData} className="btn btn-outline btn-grey-fill float-right">
                Clear all
                  </Button>
            }
          </div>
        </Col>
      </Row>
    );
  }
}
